//import CoolenWordGroupResultPopup from "@/pages/comp/coolen/word_group/result/popup/group_result";
import CoolenWordGroupResultArea from "@/pages/comp/coolen/word_group/common/group_result";

function CoolenWordGroupResultPopup(props: any) {
  let myProps = {
    g_par_id:"",
    g_par_seq:"",
    stu_seq:"",
    callBackData:(inData:any)=>{},
    closePopup: () => {},
    ...props
  };
  return (
    <div>
      <CoolenWordGroupResultArea
        g_par_id={myProps.g_par_id}
        g_par_seq={myProps.g_par_seq}
        stu_seq={myProps.stu_seq}
        callBackData={myProps.callBackData}
        closePopup={myProps.closePopup}
      ></CoolenWordGroupResultArea>
    </div>
  );
}

export default CoolenWordGroupResultPopup;